import { useState } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';

const Item = ({ item, insertAndClosePopover, editCaption, openDeleteModal }) => {
    const { t } = useTranslation('publishing');
    const [areButtonsDisplayed, setButtonsDisplayed] = useState(false);

    return (
        <div
            className="relative w-full rounded-m bg-icoGray-100 p-5 text-left text-xs hover:opacity-90 dark:bg-icoDarkMode-deepBlack"
            onMouseEnter={() => setButtonsDisplayed(true)}
            onMouseLeave={() => setButtonsDisplayed(false)}>
            <p className="mb-1 font-GSemiBold">{item.title}</p>
            <p className="line-clamp-3 font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                {item.text}
            </p>
            {areButtonsDisplayed && (
                <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center gap-8 rounded-m bg-icoGray-300 p-5 text-left text-xs text-icoGray-500 dark:bg-icoDarkMode-deepBlack dark:text-icoDarkMode-wolf">
                    <button
                        onClick={() => insertAndClosePopover(item.text)}
                        className="flex flex-col items-center justify-center gap-1 hover:text-icoBlue">
                        <Icon icon="plus" />
                        {t('captions_and_lists.popover.insert')}
                    </button>
                    <button
                        onClick={editCaption}
                        className="flex flex-col items-center justify-center gap-1 hover:text-icoBlue">
                        <Icon icon="edit" />
                        {t('commons:edit')}
                    </button>
                    <button
                        onClick={openDeleteModal}
                        className="flex flex-col items-center justify-center gap-1 hover:text-icoBlue">
                        <Icon icon="trash" />
                        {t('commons:delete')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Item;
